import { Clips } from '@air/api';
import { type Board, type Clip, ClipSource } from '@air/api/types';
import { type Upload } from '@air/redux-uploader';
import { callRequestWithRetry } from '@air/upload-utils';
import { reportErrorToBugsnag } from '@air/utils-error';

type GetSmallPrivateUploadUrlsParams = {
  apiUploadData: Upload['apiUploadData'][];
  assetId?: Clip['assetId'];
  parentBoardId?: Board['id'];
  workspaceId: string;
};

export const fetchSmallPrivateUploadUrl = async ({
  apiUploadData,
  parentBoardId,
  assetId,
  workspaceId,
}: GetSmallPrivateUploadUrlsParams) => {
  try {
    const urls = await callRequestWithRetry(() =>
      Clips.getUploadUrls({
        workspaceId,
        options: {
          files: apiUploadData,
          source: ClipSource.web,
          ...(parentBoardId ? { boardId: parentBoardId } : {}),
          ...(assetId ? { assetId } : {}),
        },
      }),
    );

    return urls;
  } catch (error) {
    throw reportErrorToBugsnag({
      error,
      context: `Failed to get private small upload url`,
      metadata: {
        data: {
          apiUploadData,
        },
      },
    });
  }
};
